import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useApiV2ModelContext } from '../../../contexts/ApiV2ModelContext';
import { PrMetricsSummary } from './PrMetricsSummary';
export const defaultMetrics = {
    workInProgress: {
        amount: 5,
        avgTime: 200,
        diff: 3,
    },
    review: {
        amount: 4,
        avgTime: 250,
        diff: -3,
    },
    merge: {
        amount: 2,
        avgTime: 100,
        diff: 6,
    },
};
const calculateDiff = (prev, cur) => prev ? Math.round((-100 * (cur - prev)) / prev) : 0;
export const PullRequestMetrics = ({ timezoneId, activeRepositoriesIds, from, to, pollInterval, link, showTimeInfo, user, }) => {
    const apiV2ModelContext = useApiV2ModelContext();
    const [loading, setLoading] = useState(true);
    const [pullRequestMetrics, setPullRequestMetrics] = useState(null);
    const fetchPullRequestMetrics = () => {
        apiV2ModelContext.watchPullRequestMetrics(timezoneId, activeRepositoriesIds, from, to, pollInterval).subscribe({
            next: (metrics) => {
                setPullRequestMetrics(metrics);
                setLoading(false);
            },
            error: (err) => console.error(err),
        });
    };
    useEffect(() => {
        fetchPullRequestMetrics();
    }, [activeRepositoriesIds, from, to]);
    if (loading || !pullRequestMetrics) {
        return (_jsx(PrMetricsSummary, { loading: loading, link: link, from: from, to: to, showTimeInfo: showTimeInfo, user: user }));
    }
    const sprints = pullRequestMetrics.pullRequestsMetrics;
    if (!sprints || sprints.length <= 1) {
        return (_jsx(PrMetricsSummary, { metrics: defaultMetrics, loading: loading, link: link, from: from, to: to, showTimeInfo: showTimeInfo, user: user }));
    }
    const previousSprint = sprints[0];
    const currentSprint = sprints[1];
    const emptySprintFilter = (sprint) => {
        return (sprint.sprint.merged.length > 0 ||
            sprint.sprint.review.length > 0 ||
            sprint.sprint.workInProgress.length > 0);
    };
    if (currentSprint && [currentSprint, previousSprint || currentSprint].filter(emptySprintFilter).length === 0) {
        return (_jsx(PrMetricsSummary, { metrics: defaultMetrics, loading: loading, link: link, from: from, to: to, showTimeInfo: showTimeInfo, user: user }));
    }
    const metrics = {
        workInProgress: {
            amount: currentSprint.sprint.workInProgress.length,
            avgTime: currentSprint.sprint.workInProgressAvgTime,
            diff: calculateDiff(previousSprint.sprint.workInProgressAvgTime, currentSprint.sprint.workInProgressAvgTime),
        },
        review: {
            amount: currentSprint.sprint.review.length,
            avgTime: currentSprint.sprint.reviewAvgTime,
            diff: calculateDiff(previousSprint.sprint.reviewAvgTime, currentSprint.sprint.reviewAvgTime),
        },
        merge: {
            amount: currentSprint.sprint.merged.length,
            avgTime: currentSprint.sprint.mergedAvgTime,
            diff: calculateDiff(previousSprint.sprint.mergedAvgTime, currentSprint.sprint.mergedAvgTime),
        },
    };
    return (_jsx(PrMetricsSummary, { metrics: metrics, loading: loading, link: link, from: from, to: to, showTimeInfo: showTimeInfo, user: user }));
};
